import { css } from "@compiled/react";
import { useIntl } from "react-intl";

import { token } from "@atlaskit/tokens";

import { ConfluenceTemplateMessages } from "@/components/confluence/templates/template-messages";
import { Template } from "@/content/templates/template.types";

import { TemplateAuthor } from "../../../../../../../components/confluence/templates/template-author";

import { TemplateCtaButtons } from "./template-cta-buttons.tsx";

const headerSectionStyles = css({
    "borderBlockEnd": "solid 1px",
    "borderBlockEndColor": token(
        "color.background.accent.gray.subtler.hovered"
    ),
    "display": "flex",
    "flexDirection": "column",
    "paddingBlockEnd": "24px",
    "@media(max-width: 768px)": {
        alignItems: "center"
    }
});

const titleStyles = css({
    "color": "#172B4D",
    "fontFamily": "Charlie Display",
    "fontSize": "52px",
    "fontStyle": "normal",
    "fontWeight": "500",
    "lineHeight": "60px",
    "marginBlockEnd": "16px",
    "marginBlockStart": 0,
    "@media(max-width: 768px)": {
        textAlign: "center"
    }
});

const subTitleStyles = css({
    "color": "#172B4D",
    "fontFamily": "Charlie Text",
    "fontSize": "20px",
    "fontStyle": "normal",
    "fontWeight": "400",
    "lineHeight": "28px",
    "marginBlockEnd": "32px",
    "marginBlockStart": 0,
    "@media(max-width: 768px)": {
        textAlign: "center"
    }
});

export type TemplateHeaderSectionProps = {
    template: Template;
};

export const TemplateHeaderSection = ({
    template
}: TemplateHeaderSectionProps) => {
    const intl = useIntl();

    const templateName = intl.formatMessage(
        ConfluenceTemplateMessages.templateTitle,
        {
            templateName: template.name ?? ""
        }
    );

    return (
        <section css={headerSectionStyles} data-testid="TemplateHeaderSection">
            <h1 css={titleStyles}>{templateName}</h1>
            <TemplateAuthor template={template} />
            <p css={subTitleStyles}>{template.oneLinerHeadline}</p>
            <TemplateCtaButtons
                name={templateName}
                pluginModuleKey={template.pluginModuleKey || ""}
            />
        </section>
    );
};
